import React from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { Flex, Button, Divider, Text, Box } from "@chakra-ui/react";
import { TextareaFormField } from "../../WorkshopDetails/BookingRequestModal/TextareaFormField";
import { InputFormField } from "../../WorkshopDetails/BookingRequestModal/InputFormField";

const REQUIRED_FIELD_TEXT = "Bitte Pflichtfeld befüllen";

export type FormData = {
  text: string;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
};

interface IFormContainer {
  onSendReportRequest: (formValues: FormData) => Promise<void>;
}

export const FormContainer: React.FC<IFormContainer> = ({
  onSendReportRequest,
}) => {
  const initialFormData = {
    company: "",
    firstName: "",
    lastName: "",
    email: "",
    mentorId: "",
    mentorName: "",
    workshopTitle: "",
    workshopId: "",
    text: "",
  };

  const validationSchema = yup.object({
    email: yup
      .string()
      .email("Bitte verwende eine valide E-Mail-Adresse")
      .required(REQUIRED_FIELD_TEXT),
    company: yup
      .string()
      .required(REQUIRED_FIELD_TEXT)
      .max(100, "Es sind maximal 100 Zeichen erlaubt")
      .min(3, "Bitte mindestens 3 Zeichen eingeben"),
    firstName: yup
      .string()
      .required(REQUIRED_FIELD_TEXT)
      .max(50, "Es sind maximal 50 Zeichen erlaubt")
      .min(3, "Bitte mindestens 3 Zeichen eingeben"),
    lastName: yup
      .string()
      .required(REQUIRED_FIELD_TEXT)
      .max(50, "Es sind maximal 50 Zeichen erlaubt")
      .min(3, "Bitte mindestens 3 Zeichen eingeben"),
    text: yup
      .string()
      .required(REQUIRED_FIELD_TEXT)
      .max(1000, "Es sind maximal 1000 Zeichen erlaubt")
      .min(3, "Bitte mindestens 3 Zeichen eingeben"),
  });

  const inputFormElements = [
    {
      name: "firstName",
      label: "Vorname",
      placeholderText: "z.B. Sabrina",
    },
    {
      name: "lastName",
      label: "Nachname",
      placeholderText: "z.B. Kaiser",
    },
    {
      name: "email",
      label: "E-Mail-Adresse",
      placeholderText: "z.B. sabrina@beispiel-email.de",
    },
    {
      name: "company",
      label: "Firmenname",
      placeholderText: "z.B. Kaiser GmbH",
    },
  ];

  const textareaFormElements = [
    {
      name: "text",
      label: "Bitte gib den Grund der Meldung an",
      placeholderText: "",
    },
  ];

  return (
    <Formik
      initialValues={initialFormData}
      onSubmit={onSendReportRequest}
      validationSchema={validationSchema}
      enableReinitialize={false}
    >
      {(formik) => {
        return (
          <Form>
            {textareaFormElements.map((element, index) => (
              <TextareaFormField
                key={index}
                name={element.name}
                label={element.label}
                placeholderText={element.placeholderText}
                formik={formik}
              />
            ))}
            <Divider my={12} />
            <Box mb={8}>
              <Text fontWeight={"bold"} fontSize={"lg"}>
                Wie können wir dich für Rückfragen kontaktieren?
              </Text>
              <Text>
                Deine Kontaktdaten werden nur für Rückfragen bzw. zur Klärung
                verwendet
              </Text>
            </Box>
            {inputFormElements.map((element, index) => (
              <InputFormField
                key={index}
                name={element.name}
                label={element.label}
                placeholderText={element.placeholderText}
                formik={formik}
              />
            ))}

            <Flex justifyContent="flex-end">
              <Button
                isLoading={formik.isSubmitting}
                type="submit"
                disabled={!(formik.isValid && formik.dirty)}
                backgroundColor="highlightColor"
                color="white"
                _hover={{
                  backgroundColor: "gray.700",
                }}
              >
                Senden
              </Button>
            </Flex>
          </Form>
        );
      }}
    </Formik>
  );
};
